export const iconFontAwesomeMoneyBangladeshiTakaSign = (
	<i className="fa-solid fa-bangladeshi-taka-sign"></i>
);
